import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import Actions from './Actions';
import Header from './Header';
import TotRev from './TotRev';
import useSWR from 'swr';
import { useEffect } from 'react';
import { Tabs } from 'components/Tabs';
import { Box } from '@mui/material';

const options = {
  scales: {
    y: {
      beginAtZero: true
    }
  },
  plugins: {
    legend: {
      display: false
    }
  },
  parsing: {
    xAxisKey: 'month',
    yAxisKey: 'value'
  },

  maintainAspectRatio: false
};

export default function Chart() {
  const [dataView, setDataView] = useState('general')
  const [chartData, setChartData] = useState([])
  // const tableData = {
  //   general: null,
  //   branch: null,
  //   pos: null
  // }

  const { data: metricsNumber } = useSWR('dashboard/loyalty-metrics')
  const { data: reviewsNumber } = useSWR('dashboard/ratings')
  const [tab, setTab] = useState('revenue')
  const createXY = (data) => {
    let x = [], y = []
    y = data?.map(obj => Object.values(obj)[0])
    x = data?.map(obj => Object.keys(obj)[0])
    return { x, y }
  }
  const getChartData = async (params) => {
    let data = params?.graph_data
    if (!data?.total_customers) {
      setChartData([createXY(data)])
    } else {
      setChartData(Object.values(data).map(createXY))
    }
  }
  const removeCommas = (string) => (typeof string === 'string') ? (string?.includes(',') ? string?.replaceAll(',', '') : string) : string
  const [metrics, setMetrics] = useState([
    { key: 'total_customers', name: 'Total Customers', number: 0, color: '#ffffff' },
    { key: 'returning_customers', name: 'Returning Customers', number: 4200, color: '#1976D2' },
    { key: 'new_customers', name: 'New Customers', number: 24, color: '#DAA200' },
    { key: 'lost_customers', name: 'Inactive Customers', number: 300, color: '#FF3B30' },
  ])

  const [reviewsCardData, setReviewsCardData] = useState([])
  useEffect(() => {
    if (metricsNumber?.data) {
      setMetrics(values => values.map(
        (x, i) => Object.assign(x, { number: Object.values(metricsNumber?.data)[i] })
      ))
    }
  }, [metricsNumber])
  useEffect(() => {
    if (reviewsNumber) {
      setReviewsCardData(reviewsNumber?.data?.data)
      setReviewsCardData(data => [...data, { label: 'total', value: reviewsNumber?.data?.total }])
    }
  }, [tab, reviewsNumber,])
  const setView = (name) => {
    setDataView(name)
  }

  const [data, setData] = useState({ labels: [], datasets: [] });
  useEffect(() => {
    setData({
      labels: chartData ? chartData[0]?.x : [],
      datasets: chartData?.map((_data, i) => {
        return {
          label: tab !== 'loyalty' ? tab.charAt(0).toUpperCase() + tab.substring(1, tab.length) + 's' : metrics[i].name,
          data: chartData ? _data?.y?.map(removeCommas) : [],
          fill: false,
          backgroundColor: tab !== 'loyalty' ? 'blue' : metrics[i].color,
          borderColor: tab !== 'loyalty' ? 'blue' : metrics[i].color,
          borderWidth: 1
        }
      })
    })
  }, [chartData, metrics, tab])

  const tabs = ['revenue', 'loyalty', 'review']

  const Loyalties = ({ name, number, color, width = '23%' }) => (
    <Box sx={{ width: { xs: '100%', lg: width } }}
      className='border rounded-[16px] my-[10px] h-[87px] p-[16px] flex justify-between items-center'>
      <div className='flex-col items-between'>
        <div className='font-bold text-[24px] text-[#05213D]'>{number}</div>
        <div className='capitalize'>{name}</div>
      </div>
      <div className={`h-[8px] flex w-[31px] bg-[${color}]`} style={{ backgroundColor: color }}></div>
    </Box>)

  return (
    <div className="w-full bg-white relative mt-4 rounded-2xl px-[40px] pb-5">

      <div className=' flex w-[100%] border-b h-[7vh]'>
        {tabs.map(current => <Tabs key={current} name={current} onClick={() => setTab(current)} on={tab === current} />)}
      </div>
      <div className='lg:flex xs:flex-col w-100 justify-between'>
        <Actions dataView={dataView} setView={setView} />
        <Header
        dataView={dataView}
        getChartData={getChartData}
        tab={tabs.indexOf(tab)}
        />
      </div>

      {
        tab === 'loyalty' && <div className='w-100 lg:flex xs:flex-col justify-between '>
          {metrics.map(metric => <Loyalties key={metric.name} {...metric} />)}
        </div>
      }
      {
        tab === 'review' && <div className='w-100 lg:flex xs:flex-col justify-between '>
          {reviewsCardData.reverse().map(({ label, value }) => <Loyalties key={label} number={value} name={label?.replace('_', ' ')} width={`${(100 / reviewsCardData.length) - 1}%`} />)}
        </div>
      }

      <div className="py-7 mx-auto   relative">
        <Line
          data={data}
          options={options}
          height={300}
          width={'100%'}
        />
      </div>
      {(tab === 'revenue') && <TotRev />}
    </div>
  )
};

